function normalizePathname(pathname) {
  return pathname.replace(/([?#].*)|\/[^/]*\.[^/]*$/g, '').replace(/\/?$/, '/');
}

function current() {
  const { pathname, origin } = window.location;
  const currentPathname = normalizePathname(pathname);

  const targets = document.querySelectorAll('.Navigation__link');

  targets.forEach((linkElement) => {
    const targetUrl = new URL(linkElement.href, origin); // 相対URLにも対応
    if (targetUrl.origin === origin) {
      const targetPathname = normalizePathname(targetUrl.pathname);

      // カレント、またはその親階層であれば `is-current` を付与
      if (
        currentPathname === targetPathname || // 完全一致
        currentPathname.startsWith(targetPathname) // 階層的部分一致
      ) {
        linkElement.classList.add('is-current');
      }
    }
  });
}

function observeDynamicContent() {
  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver(() => {
    current();
  });

  observer.observe(targetNode, config);
}

// 初期化関数
export default function initCurrent() {
  current(); // 初回実行
  observeDynamicContent(); // 動的変化の監視を開始
}
